module.exports = __webpack_public_path__ + "static/solution01-icon-3000cf58255d3de6a7c7fd322e8a9e26.png";